<template>
  <div id="revenueCenters">

    <PageTitle :title="$t('revenue_centers.title')" :subtitle="$t('revenue_centers.subtitle')">
      <button class="btn btn-primary" @click="newRevenueCenter">{{$t('revenue_centers.new')}}</button>
    </PageTitle>

    <PageContainer>

      <Empty v-if="revenueCenters.length === 0" :text="$t('revenue_centers.empty')"
             :button="{text: $t('revenue_centers.new'), action: newRevenueCenter}"></Empty>

      <table class="table" v-if="revenueCenters.length > 0">
        <tr>
          <th class="icon"></th>
          <th class="name">{{$t('name')}}</th>
          <th class="services">{{$t('services.title')}}</th>
          <th>{{$t('revenue_centers.included_items')}}</th>
          <th>{{$t('description')}}</th>
          <th>&nbsp;</th>
        </tr>
        <tr v-for="(revenueCenter, revenueCenterIndex) of revenueCenters" :key="'rc-' + revenueCenterIndex">
          <td class="icon">
            <div class="table__icon">
              <svgicon src="icon/nav/inventory.svg" :height="16" :width="16"></svgicon>
            </div>
          </td>
          <td class="name">{{$to(revenueCenter.name)}}</td>
          <td>
            <div class="services">
              <Tag grey v-for="(service, serviceIndex) of revenueCenter.config.services" :key="'service' + revenueCenterIndex + serviceIndex">
                {{$t('catalog.' + service)}}
              </Tag>
            </div>
          </td>
          <td>{{getItemsCount(revenueCenter.catalog)}}</td>
          <td>{{$to(revenueCenter.description)}}</td>
          <td class="menu-items">
            <div class="actions">
              <ActionMenu icon="/icon/actions-horizontal.png">
                <div class="item" @click="editRevenueCenter(revenueCenter)">{{$t('edit')}}</div>
                <div class="item" @click="removeRevenueCenter(revenueCenter, revenueCenterIndex)">{{$t('remove')}}</div>
              </ActionMenu>
            </div>
          </td>
        </tr>
      </table>
    </PageContainer>

  </div>
</template>

<script>
  import ActionMenu from "@/components/tools/ActionMenu";
  import Empty from "@/components/tools/Empty";
  import PageContainer from "@/components/PageContainer";
  import Tag from "@/components/tools/Tag";
  import PageTitle from "@/components/PageTitle";
  import {mapActions} from "vuex";

  export default {
    name: "RevenueCenters",

    components: { ActionMenu, PageContainer, Empty, PageTitle, Tag },

    data() {
      return {
        revenueCenters: []
      }
    },

    computed: {
      companyId() {
        return this.$route.query.company;
      }
    },

    async mounted() {
      showSpinner();
      this.$store.state.pageTitleTranslationKey = "revenue_centers.title";
      this.$store.state.pageIcon = "/icon/nav/inventory.svg";
      await this.loadRevenueCenters();
      hideSpinner();
    },

    methods: {
      ...mapActions(["deleteRevenueCenter", "getRevenueCenters"]),

      async loadRevenueCenters() {
        let response = await this.getRevenueCenters(this.companyId);
        if (response && response.revenueCenters) {
          this.revenueCenters = response.revenueCenters;
        }
      },

      getItemsCount(catalog) {
        return catalog.categories.reduce((categoryTotal, category) => categoryTotal + category.items.reduce((itemTotal, item) => itemTotal + 1, 0), 0);
      },

      editRevenueCenter(revenueCenter) {
        this.$router.push(this.$router.buildContext("/revenue-center/edit", {id: revenueCenter.id}));
      },
      async removeRevenueCenter(revenueCenter, index) {
        let confirm = await showConfirmation(this.$t("warning"), this.$t("revenue_centers.delete_confirmation").replace("{RC}", this.$to(revenueCenter.name)));
        if (!confirm) {
          return;
        }
        showSpinner();
        let response = await this.deleteRevenueCenter(revenueCenter.id);
        hideSpinner();
        if (response) {
          toast(this.$t('revenue_centers.delete_success'), "success", this.$t("success"));
          this.revenueCenters.splice(index, 1);
        } else {
          toast(this.$t('revenue_centers.delete_error'), "error", this.$t("error.title"));
        }
      },
      newRevenueCenter() {
        this.$router.push(this.$router.buildContext("/revenue-center/new"));
      }
    }
  }
</script>

<style lang="scss" scoped>
  #revenueCenters {
    display: flex;
    flex-direction: column;


    .table {
      width: 100%;

      tr {
        &:not(:last-child) {
          td, th {
            border-bottom: 1px solid #e6e6e6;
          }
        }
      }

      .table__icon {
        height: 32px;
        width: 32px;
        display: flex;
        border-radius: 6px;
        background-color: #f5f5f5;
        align-items: center;
        justify-content: center;
        fill: #ccc;
        margin-right: 16px;
      }

      td, th {
        &.icon {
          width: 1px;
        }
      }

      th {
        text-align: left;
        font-size: 14px;
        padding-bottom: 16px;
      }

      td {
        padding-top: 16px;
        padding-bottom: 16px;
        &:first-child {
          padding-left: 16px;
        }
        &:last-child {
          padding-right: 16px;
        }
      }

      .tag {
        margin-right: 5px;
        margin-bottom: 5px;
      }
    }

    .menu-items {
      width: 1px;
    }

    .actions {
      height: 32px;
      width: 100%;
    }
  }
</style>